import React from 'react';
import {ListGroup} from 'react-bootstrap';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';
import {decode as base64_decode} from 'base-64';

const NavGroup = ({layout, group}) => {
  const storageRaw = sessionStorage.getItem('ddesp');
  const storage = storageRaw ? JSON.parse(base64_decode(storageRaw)) : [];
  const parametrosConta = typeof storage?.[39] === 'object' && storage[39] !== null && !Array.isArray(storage[39]) ? storage[39] : {};
  const contaRecursosHidratado = parametrosConta?.__contaRecursosHidratado === true;
  const nfeAtivo = !contaRecursosHidratado || parametrosConta?.['14'] !== false;
  const cteAtivo = !contaRecursosHidratado || parametrosConta?.['15'] !== false;
  const nfseAtivo = !contaRecursosHidratado || parametrosConta?.['16'] !== false;
  const nfceAtivo = !contaRecursosHidratado || parametrosConta?.['17'] !== false;
  const idsOcultos = new Set(['32', '37', '38']);

  if (!nfeAtivo) {
    idsOcultos.add('3');
    idsOcultos.add('15');
    idsOcultos.add('17');
  }

  if (!cteAtivo) {
    idsOcultos.add('5');
    idsOcultos.add('18');
  }

  if (!nfseAtivo) {
    idsOcultos.add('24');
  }

  if (!nfceAtivo) {
    idsOcultos.add('23');
    idsOcultos.add('25');
  }

  let navItems = '';

  if (group.children) {
    const groups = group.children.filter((item) => !idsOcultos.has(String(item.id)));

    if (groups.length === 0) {
      return null;
    }

    navItems = Object.keys(groups).map((item) => {
      item = groups[item];

      switch (item.type) {
        case 'collapse':
          return (
            <NavCollapse
              key={item.id}
              collapse={item}
              type='main'
            />
          );
        case 'item':
          return (
            <NavItem
              layout={layout}
              key={item.id}
              item={item}
            />
          );
        default:
          return false;
      }
    });
  }

  return (
    <React.Fragment>
      <ListGroup.Item
        as='li'
        bsPrefix=' '
        key={group.id}
        className='nav-item pcoded-menu-caption'
      >
        <label className='text-capitalize'>{group.title}</label>
      </ListGroup.Item>
      {navItems}
    </React.Fragment>
  );
};

export default NavGroup;
